import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/AllProjects.css';
import allprojectimg from "../../components/img/allprojectimg.jpg";

const AllProjects = () => {
  const [isInView, setIsInView] = useState(false);
  const [runningProjects, setRunningProjects] = useState([]);

  // Fetch running projects (category_id=1)
  useEffect(() => {
    fetch("https://adinathbuilder.com/admin/api/projects?category_id=1")
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setRunningProjects(data.data.slice(0, 5)); // Show only 5 records
        }
      })
      .catch((err) => console.error("Error fetching running projects:", err));
  }, []);

  // Animation on view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.5 }
    );

    const element = document.querySelector('.single-project-container');
    if (element) observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  return (
    <div className={`single-project-container ${isInView ? 'in-view' : ''}`}>
      <div className="image-section">
        <img
          src={allprojectimg}
          alt="Current Project"
          className="project-image"
        />
      </div>

      <div className="text-section text-start">
        <h2 className='text-start'>Our Best Running Projects</h2>
        <p>
          Currently, we are working on several high-quality <br /> construction
          projects, including <br />
          {runningProjects.map((project, index) => (
            <span key={project.id}>
              <strong>{project.name}</strong>{index !== runningProjects.length - 1 && <>,<br /></>}
            </span>
          ))}
          <br />
          These projects offer premium living spaces designed to meet the highest standards of comfort and quality.
        </p>
        <Link to="/running-projects" className="shake-view-projects-btn">
          View All Projects
        </Link>
      </div>
    </div>
  );
};

export default AllProjects;
